import { DrawerHeaderProps } from '@react-navigation/drawer';
import React, { useContext, useEffect } from 'react';

import { AppMenuContext } from './context';

export const HeaderPlaceholder: React.FC<DrawerHeaderProps> = ({ navigation }) => {
  const { setIsOpen } = useContext(AppMenuContext);

  const state = navigation.getState();
  const isDrawerOpen =
    state.history.filter((route) => route.type === 'drawer' && route.status === 'open').length > 0;

  useEffect(() => {
    if (isDrawerOpen) {
      setIsOpen(true);
    } else {
      setIsOpen(false);
    }
  }, [isDrawerOpen, setIsOpen]);

  return null;
};
